import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() { }

  public setCookie(name: string, value: string, days: number = 1) {
    var dateToExpires = new Date();
    dateToExpires.setTime(dateToExpires.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + dateToExpires.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  public getCookie(name: string): string | null {
    const nombreEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(nombreEQ) === 0) {
        return cookie.substring(nombreEQ.length, cookie.length);
      }
    }
    return null;
  }

  public deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
